import { IconProps } from "../../utils/global-types/global-types";

const ActiveUserIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M7.72 2.333a2.996 2.996 0 1 0 0 5.993 2.996 2.996 0 0 0 0-5.993M8.019 9.79c.168-.245.006-.618-.29-.619H6.93a4.46 4.46 0 0 0-4.46 4.46 1.82 1.82 0 0 0 1.82 1.819h3.481c.3 0 .462-.383.288-.627a4.37 4.37 0 0 1-.813-2.546c0-.924.285-1.78.772-2.488"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.027 12.277a3.39 3.39 0 1 1-6.78 0 3.39 3.39 0 0 1 6.78 0m-1.45-1.289a.5.5 0 0 1 .046.706l-1.712 1.955a.833.833 0 0 1-1.22.037l-.962-.974a.5.5 0 0 1 .712-.703l.584.591c.136.138.36.132.488-.014l1.358-1.551a.5.5 0 0 1 .706-.047"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default ActiveUserIcon;
